// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sources-container {
    height: 100vh;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/DatasetsView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;AACjB","sourcesContent":[".sources-container {\n    height: 100vh;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
